import React from 'react';

const MainNavbarContext = React.createContext();

export default MainNavbarContext;
